module.exports = __webpack_public_path__ + "img/pluto89.ef41c4ab.jpg";